
<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap">
      <el-form ref="form" :rules="rules" :model="formdata" label-width="120px">
        <!-- <el-form-item>
          <el-radio v-model="formdata.name" label="1">添加部门</el-radio>
        </el-form-item>-->
        <el-form-item label="部门名称:" prop="name">
          <el-input v-model="formdata.name" class="w340" placeholder="请输入部门名称"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="save('form')">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import api from "@/api.js";
export default {
  name: "addOrgDialog",
  props: ["visible", "parentDepartId", "departId", "departName"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  data() {
    return {
      title: "新增部门",
      dialogVisible: this.visible,
      formdata: {
        name: ""
      },
      lock: true,
      rules: {
        name: [{ required: true, message: "请输入部门名称", trigger: "blur" }]
      }
    };
  },
  created() {
    if (this.departId) {
      this.title = "编辑部门";
      this.formdata.name = this.departName;
    }
  },
  methods: {
    // 保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.lock) {
            this.lock = false;
            if (this.departId) {
              this.submiteditsave();
            } else {
              this.submitsave();
            }
          }
        } else {
          return false;
        }
      });
    },
    // 提交保存
    submitsave() {
      let params = {
        name: this.formdata.name,
        parent_id: this.parentDepartId
      };
      this.axios
        .post(api.department_add, params)
        .then(response => {
          this.lock = true;
          if (response.data.code == 0) {
            this.$message({
              message: "保存部门成功",
            });
            this.$emit("addeditdepsucess");
            this.dialogVisible = false;
          } else {
          }
        })
        .catch(response => {
          this.lock = true;
        });
    },
    // 提交编辑保存
    submiteditsave() {
      let params = {
        name: this.formdata.name,
        depart_id: this.departId
      };
      this.axios
        .post(api.department_edit, params)
        .then(response => {
          this.lock = true;
          if (response.data.code == 0) {
            this.$message({
              message: "修改部门成功",
            });
            this.$emit("addeditdepsucess");
            this.dialogVisible = false;
          } else {
          }
        })
        .catch(response => {
          this.lock = true;
        });
    }
  }
};
</script>

